<template>
	<div id="newContentSlide" v-if="!isHidden">
		<div class="overlayFullscreen">
			<div class="overlayContainer">

				<OverlayHeader v-bind:title="title"/>

				<UploadSpinner v-if="isInSave"/>

				<div class="contentWrapper">
					<div class="left">
						<h3 class="headline">Bild / Video</h3>
						<img v-if="!blockInterface && showImageFlag"
							 v-bind:src="getMedia"/>
						<video v-if="!blockInterface && showVideoFlag"
							   v-bind:src="getMedia" controls/>
						<div v-else class="button" v-on:click="openFileBrowser">
							<p>Datei auswählen...</p>
						</div>
						<input type="file" ref="fileInput" name="media"
							   accept="image/png, image/jpeg, video/webm, video/mp4, video/quicktime"
							   style="display: none;">
						<div v-if="blockInterface" class="description">
							{{contentType == 'model' ? getModelDescription :
							getWallDescription}}
						</div>
						<p>{{getFileName}}</p>
					</div>

					<Notes class="middle"
						   v-bind:disabled="blockInterface"
						   v-bind:title.sync="slideTitle"
						   v-bind:text.sync="slideText"/>

					<div class="right">
						<h3 class="headline">Tags</h3>
						<div class="tags" v-bind:key="tag.id"
							 v-for="tag in tags">
							<Tag v-bind:tag="tag"
								 v-bind:isSelected="isSelected(tag)"
								 @onClicked="onTagSelected(tag)"/>
						</div>
					</div>
				</div>

				<div class="saveCancelButtons">
					<div class="button"
						 :class="{buttonDisabled: blockInterface}"
						 v-on:click="onSave">
						<p>Speichern</p>
					</div>
					<div class="button" v-on:click="isHidden=true">
						<p>Abbrechen</p>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import {EventBus} from '@/services/EventBus.js';
	import ContentLoader from '@/services/ContentLoader.js';
	import OverlayHeader from '@/components/layout/OverlayHeader.vue';
	import Notes from '@/components/layout/Notes.vue';
	import Tag from '@/components/tags/Tag.vue';
	import UploadSpinner from '@/components/content/UploadSpinner.vue';

	export default {
		name: "NewContentSlide",
		components: {
			OverlayHeader,
			Notes,
			Tag,
			UploadSpinner
		},
		data() {
			return {
				isHidden: true,
				title: '',
				slide: '',
				slideTitle: '',
				slideText: '',
				tags: [],
				slideTags: [],
				mediaUrl: '',
				fileName: '',
				contentType: '',
				blockInterface: true,
				modelWidth: 2330,
				modelHeight: 1280,
				wallWidth: 1920,
				wallHeight: 1080,
				showImageFlag: false,
				showVideoFlag: false,
				fileTypes: ["image/png", "image/jpeg", "video/webm", "video/mp4", "video/quicktime"],
				isInSave: false,
				msgFiletype: 'Falscher Dateityp\n\nZulässige Dateitypen sind: ',
				msgDimensions: 'Falsche Auflösung\n\nDie Datei muss folgende Auflösung haben: '
			}
		},
		computed: {
			getMedia() {
				return this.mediaUrl;
			},
			getFileName() {
				return this.fileName;
			},
			getModelDescription() {
				return 'Auflösung (B x H): ' + this.modelWidth + ' x ' + this.modelHeight + ' px';
			},
			getWallDescription() {
				return 'Optimale Auflösung (B x H): ' + this.wallWidth + ' x ' + this.wallHeight + ' px';
			},
			getDimensionsAlert() {
				return this.msgDimensions + '\n' + this.modelWidth + ' x ' + this.modelHeight + ' px';
			},
			getFileTypeAlert() {
				return this.msgFiletype + '\n' + this.fileTypes;
			}
		},
		methods: {
			openFileBrowser() {
				this.$refs.fileInput.click();
				this.$refs.fileInput.onchange = e => {
					this.loadMedia(e.target.files[0]);
				}
			},
			async loadMedia(file) {
				this.isInSave = true;
				var fileReader = new FileReader();

				fileReader.onload = e => {
					if (this.validFileType(file)) {
						if (file.type.includes('video')) {
							this.showVideo(e.target.result, file.name);
						} else {
							var image = new Image;
							image.onload = () => {
								this.validDimensions(image) ? this.showImage(e.target.result, file.name) : alert(this.getDimensionsAlert);
							};
							image.src = e.target.result;
						}
					} else {
						alert(this.getFileTypeAlert);
					}
				}

				fileReader.readAsDataURL(file);

				setTimeout(function () {
					this.isInSave = false;
				}.bind(this), 1000);
			},
			showImage(url, filename) {
				this.showImageFlag = true;
				this.showVideoFlag = false;
				this.setMediaMetaData(url, filename);
			},
			showVideo(url, filename) {
				this.showVideoFlag = true;
				this.showImageFlag = false;
				this.setMediaMetaData(url, filename);
			},
			setMediaMetaData(url, filename) {
				this.mediaUrl = url;
				this.fileName = filename;
				this.slideTitle = this.createDefaultTitle();
				this.blockInterface = false;
			},
			validDimensions(image) {
				if (this.contentType == 'model') {
					return image.width == this.modelWidth && image.height == this.modelHeight;
				} else return true;
			},
			validFileType(file) {
				return this.fileTypes.includes(file.type);
			},
			createDefaultTitle() {
				var t = this.fileName.slice(0, this.fileName.lastIndexOf(".")).replace(/_/g, " ");
				return t;
			},
			async onSave() {
				this.isInSave = true;
				var formData = new FormData();
				var fileInput = this.$refs['fileInput'];
				var file = fileInput.files[0];
				formData.append(`files.${fileInput.name}`, file, file.name);
				//formData.append('files.${fileInput.name}', file, file.name);
				//formData.append(this.$refs['fileInput'].name, file, file.name);
				//formData.append('media', file, file.name);

				var data = {};
				data['type'] = this.contentType;
				data['title'] = this.slideTitle;
				data['text'] = this.slideText;
				data['tags'] = this.slideTags;
				formData.append('data', JSON.stringify(data));

				await ContentLoader.createNewSlide(formData, this.contentType);
				EventBus.$emit('onNewSlideCreated', this.contentType);

				this.isHidden = true;
				setTimeout(function () {
					this.isInSave = false;
				}.bind(this), 1000);
			},
			isSelected(currentTag) {
				var found = false;
				this.slideTags.forEach(tag => {
					if (tag.name === currentTag.name) found = true;
				});
				return found;
			},
			onTagSelected(currentTag) {
				if (this.isSelected(currentTag)) {
					for (var i = 0; i < this.slideTags.length; i++) {
						if (this.slideTags[i].name === currentTag.name) {
							this.slideTags.splice(i, 1);
							break;
						}
					}
				} else {
					this.slideTags.push(currentTag);
				}
			}
		},
		async created() {
			this.tags = await ContentLoader.loadTags();
		},
		mounted() {
			EventBus.$on('onNewSlide', type => {
				//console.log("Create new slide for "+type);
				this.contentType = type;
				this.title = 'Neues ' + ((type == 'model') ? 'Modell-' : 'Wand-') + 'Slide hochladen';
				this.slide = '';
				this.slideTitle = '';
				this.slideText = '';
				this.fileName = '';
				this.mediaUrl = '';
				this.slideTags = [];
				this.blockInterface = true;
				this.isHidden = false;
			});
		}
	}
</script>

<style scoped>
	.overlayContainer {
		display: flex;
		flex-direction: column;
		overflow: auto;
	}

	.overlayContainer .saveCancelButtons {
		position: inherit;
	}

	.description {
		margin-top: 20px;
		margin-left: 10px;
	}

	.contentWrapper {
		position: relative;
		display: flex;
		justify-content: space-around;
	}

	.contentWrapper img,
	.contentWrapper video {
		width: 100%;
	}

	.left, .middle, .right {
		height: 100%;
		margin: 10px;
		padding: 5px;
	}

	.left {
		width: 30%;
	}

	.middle {
		width: 30%;
	}

	.right {
		width: 20%;
	}

	.headline {
		margin-top: 20px;
		margin-bottom: 20px;
	}

	img {
		width: 100%;
		object-fit: contain;
		border: 1px solid black;
	}

	video {
		width: 100%;
	}

	.tags {
		width: 100%;
		display: flex;
		align-items: left;
		justify-content: left;
	}

</style>